'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveState = exports.onChangeFormat = exports.onChangeInclude = exports.sendRules = exports.getRules = exports.SEND_RULES = exports.GET_RULES = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.fetchRulesSaga = fetchRulesSaga;
exports.fetchSendRulesSaga = fetchSendRulesSaga;
exports.watchFecthGetRulesSaga = watchFecthGetRulesSaga;
exports.watchSendRulesSaga = watchSendRulesSaga;

var _reduxSaga = require('redux-saga');

var _effects = require('redux-saga/effects');

var _reactRouterRedux = require('react-router-redux');

var _api = require('helpers/api');

var _api2 = _interopRequireDefault(_api);

var _notifications = require('redux/modules/notifications');

var _createFetchTypes = require('../utils/createFetchTypes');

var _createFetchTypes2 = _interopRequireDefault(_createFetchTypes);

var _fetchEntitySaga = require('../utils/fetchEntitySaga');

var _fetchEntitySaga2 = _interopRequireDefault(_fetchEntitySaga);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(fetchRulesSaga),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(fetchSendRulesSaga),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(watchFecthGetRulesSaga),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(watchSendRulesSaga);

var CHANGE_FORMAT = 'CHANGE_FORMAT';
var CHANGE_INCLUDE = 'CHANGE_INCLUDE';
var SAVE_STATE = 'SAVE_STATE';

var GET_RULES = exports.GET_RULES = (0, _createFetchTypes2.default)('tq-plus-admin/GET_RULES');
var SEND_RULES = exports.SEND_RULES = (0, _createFetchTypes2.default)('tq-plus-admin/SEND_RULES');

var initialState = {
  templateId: '',
  rules: {},
  error: null,
  oldState: {}
};

/* REDUCER
 * ---------------------------------------------------------------------------------------------- */
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {

    case GET_RULES.REQUEST:
      {
        return state;
      }
    case GET_RULES.SUCCESS:
      {
        return (0, _extends3.default)({}, state, {
          templateId: action.templateId,
          rules: action.rules,
          rulesFormat: action.rulesFormat
        });
      }
    case GET_RULES.FAILURE:
      {
        return (0, _extends3.default)({}, state, {
          error: action.error
        });
      }

    case SEND_RULES.REQUEST:
      {
        return state;
      }
    case SEND_RULES.SUCCESS:
      {
        return state;
      }
    case SEND_RULES.FAILURE:
      {
        return (0, _extends3.default)({}, state, {
          error: action.error
        });
      }

    case CHANGE_FORMAT:
      {
        var _action$payload = action.payload,
            formatId = _action$payload.formatId,
            ruleId = _action$payload.ruleId;

        var nextSelectedRules = [];
        var found = false;

        state.rules.selectedRules.forEach(function (rule) {
          if (rule.tqRuleCategoryIdFky === ruleId) {
            found = true;
            nextSelectedRules.push((0, _extends3.default)({}, rule, {
              tqRuleFormatIdFky: formatId
            }));
          } else {
            nextSelectedRules.push(rule);
          }
        });

        if (!found) {
          nextSelectedRules.push({
            id: 0,
            include: true,
            tqTemplateIdFky: state.rules.templateId,
            tqRuleCategoryIdFky: ruleId,
            tqRuleFormatIdFky: formatId
          });
        }

        return (0, _extends3.default)({}, state, {
          rules: (0, _extends3.default)({}, state.rules, {
            selectedRules: nextSelectedRules
          })
        });
      }

    case CHANGE_INCLUDE:
      {
        var _action$payload2 = action.payload,
            _ruleId = _action$payload2.ruleId,
            include = _action$payload2.include;

        var _nextSelectedRules = [];

        state.rules.selectedRules.forEach(function (rule, i) {
          if (rule.tqRuleCategoryIdFky === _ruleId) {
            _nextSelectedRules.push((0, _extends3.default)({}, rule, { include: include }));
          } else {
            _nextSelectedRules.push(rule);
          }
        });

        return (0, _extends3.default)({}, state, {
          rules: (0, _extends3.default)({}, state.rules, {
            selectedRules: _nextSelectedRules
          })
        });
      }

    case SAVE_STATE:
      {
        var newOldState = (0, _extends3.default)({}, state.rules);
        return (0, _extends3.default)({}, state, { oldState: newOldState });
      }

    default:
      {
        return state;
      }

  }
}

/* ACTIONS
 * ---------------------------------------------------------------------------------------------- */

var getRules = exports.getRules = {
  base: function base(template, token) {
    return {
      type: GET_RULES.BASE,
      url: '/template-configuration/get-templaterules',
      params: { templateId: template },
      token: token
    };
  },
  request: function request() {
    return { type: GET_RULES.REQUEST };
  },
  success: function success(result) {
    return {
      type: GET_RULES.SUCCESS,
      templateId: result.templateId,
      rules: result
    };
  },
  failure: function failure(error) {
    return { type: GET_RULES.FAILURE, error: error };
  }
};

var sendRules = exports.sendRules = {
  base: function base(token) {
    return {
      type: SEND_RULES.BASE,
      url: '/template-configuration/save-templaterules',
      token: token
    };
  },
  request: function request() {
    return { type: SEND_RULES.REQUEST };
  },
  success: function success(result) {
    return {
      type: SEND_RULES.SUCCESS,
      templateId: result.templateId,
      rules: result
    };
  },
  failure: function failure(error) {
    return { type: SEND_RULES.FAILURE, error: error };
  }
};

/**
@param {number} ruleId - id of the rule
@param {boolean} include - whether the rule should be included or not
*/
var onChangeInclude = exports.onChangeInclude = function onChangeInclude(ruleId, include) {
  return {
    type: CHANGE_INCLUDE,
    payload: {
      ruleId: ruleId,
      include: include
    }
  };
};

/**
@param {number} formatId - format id
@param {number} ruleId - rule id
*/
var onChangeFormat = exports.onChangeFormat = function onChangeFormat(formatId, ruleId) {
  return {
    type: CHANGE_FORMAT,
    payload: {
      formatId: formatId,
      ruleId: ruleId
    }
  };
};

var saveState = exports.saveState = function saveState() {
  return { type: SAVE_STATE };
};

/* SAGAS
 * ---------------------------------------------------------------------------------------------- */
function fetchRulesSaga(_ref) {
  var url = _ref.url,
      params = _ref.params,
      token = _ref.token;
  var result;
  return _regenerator2.default.wrap(function fetchRulesSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.call)(function () {
            return (0, _fetchEntitySaga2.default)(getRules, _api2.default.get, url, { params: params, token: token });
          });

        case 3:
          result = _context.sent;
          return _context.abrupt('return', result);

        case 7:
          _context.prev = 7;
          _context.t0 = _context['catch'](0);
          _context.next = 11;
          return (0, _effects.put)((0, _notifications.error)({
            title: 'Error getting Rules',
            message: _context.t0.message
          }));

        case 11:
          console.error(_context.t0);
          return _context.abrupt('return', _context.t0);

        case 13:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[0, 7]]);
}

function fetchSendRulesSaga(_ref2) {
  var url = _ref2.url,
      token = _ref2.token;
  var selectedRules, data, result;
  return _regenerator2.default.wrap(function fetchSendRulesSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.select)(function (state) {
            return state.rules.rules.selectedRules;
          });

        case 2:
          selectedRules = _context2.sent;

          console.log(selectedRules);
          data = {
            templateRules: (0, _stringify2.default)(selectedRules)
          };
          _context2.prev = 5;
          _context2.next = 8;
          return (0, _effects.call)(_fetchEntitySaga2.default, sendRules, _api2.default.post, url, { data: data, token: token });

        case 8:
          result = _context2.sent;
          return _context2.abrupt('return', result);

        case 12:
          _context2.prev = 12;
          _context2.t0 = _context2['catch'](5);
          _context2.next = 16;
          return (0, _effects.put)((0, _notifications.error)({
            title: 'Error sending Rules',
            message: _context2.t0.message
          }));

        case 16:
          return _context2.abrupt('return', _context2.t0);

        case 17:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this, [[5, 12]]);
}

/* WATCHERS
 * ---------------------------------------------------------------------------------------------- */
function watchFecthGetRulesSaga() {
  return _regenerator2.default.wrap(function watchFecthGetRulesSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          return _context3.delegateYield((0, _reduxSaga.takeLatest)(GET_RULES.BASE, fetchRulesSaga), 't0', 1);

        case 1:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function watchSendRulesSaga() {
  return _regenerator2.default.wrap(function watchSendRulesSaga$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          return _context4.delegateYield((0, _reduxSaga.takeLatest)(SEND_RULES.BASE, fetchSendRulesSaga), 't0', 1);

        case 1:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/rules.js
// module id = 352
// module chunks = 0